export default __webpack_public_path__ + "static/media/thumbnail.37220a7c.png";